<template>
  <div class="product" style="height: calc(100vh - 120px)">
    <div class="product-content h-full">
      <div class="h-full o-hidden" style="border: 1px solid #EDEDED;">
        <el-row class="h-full">
          <el-col :span="3" class="h-full" style="border-right: 1px solid #EDEDED">
            <div class=" h-full flex-s-0">
              <div class="fs-16 flex a-center p-h-15"
                   style="color: #333333;height: 50px;border-bottom: 1px solid #EDEDED;">
                <slot name="classType">
                  <div class="fs-14">分类</div>
                </slot>
                <div class="flex-1"></div>
                <div @click="addClick(1)" class="flex a-center">
                  <span class="fs-14" style="color: #0652DD;cursor: pointer">添加</span>
                </div>
              </div>
              <div class="o-y-auto noscroll" style="height: calc(100% - 50px)">
                <ul>
                  <li v-for="(item,index) in tableData" :key="index" :class="{'active': typeTypeId === item.id}"
                      @click="onTypeTypeSelect(item)"
                      class="w-full p-h-15 lh-40 h-40 liHover flex a-center j-between">
                    {{ item.name }}
                    <div :class="{'selectHover1':typeTypeId === item.id}" class="selectHover d-none">
                      <img @click.stop="editClick(item)" alt="" class="w-15 h-15 m-r-10"
                           src="../../../assets/common/ic_xiugai.png">
                      <img @click.stop="delClick(item,1)" alt="" class="w-15 h-15"
                           src="../../../assets/common/ic_shanchu1.png">
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
          <el-col :span="3" class="h-full" style="border-right: 1px solid #EDEDED">
            <div class=" h-full flex-s-0">
              <div class="fs-16 flex a-center p-h-15"
                   style="color: #333333;height: 50px;border-bottom: 1px solid #EDEDED;">
                <slot name="classType">
                  <div class="fs-14">分组分类</div>
                </slot>
                <div class="flex-1"></div>
                <div @click="addClick(2)" class="flex a-center" v-if="typeTypeId">
                  <span class="fs-14" style="color: #0652DD;cursor: pointer">添加</span>
                </div>
              </div>
              <div class="o-y-auto noscroll" style="height: calc(100% - 50px)">
                <ul>
                  <li v-for="(item,index) in typeData" :key="index" :class="{'active': typeId === item.id}"
                      @click="onTypeSelect(item)"
                      class="w-full p-h-15 lh-40 h-40 liHover flex a-center j-between">
                    {{ item.name }}
                    <div :class="{'selectHover1':typeId === item.id}" class="selectHover d-none">
                      <img @click.stop="editClick(item)" alt="" class="w-15 h-15 m-r-10"
                           src="../../../assets/common/ic_xiugai.png">
                      <img @click.stop="delClick(item,1)" alt="" class="w-15 h-15"
                           src="../../../assets/common/ic_shanchu1.png">
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
          <el-col :span="3" class="h-full" style="border-right: 1px solid #EDEDED">
            <div class=" h-full flex-s-0">
              <div class="fs-16 flex a-center p-h-15"
                   style="color: #333333;height: 50px;border-bottom: 1px solid #EDEDED;">
                <slot name="classType">
                  <div class="fs-14">商品分组</div>
                </slot>
                <div class="flex-1"></div>
                <div @click="addClick(3)" class="flex a-center" v-if="typeId">
                  <span class="fs-14" style="color: #0652DD;cursor: pointer">添加</span>
                </div>
              </div>
              <div class="o-y-auto noscroll" style="height: calc(100% - 50px)">
                <ul>
                  <li v-for="(item,index) in groupData" :key="index" :class="{'active': groupId === item.id}"
                      @click="onGroupSelect(item)"
                      class="w-full p-h-15 lh-40 h-40 liHover flex a-center j-between">
                    {{ item.name }}
                    <div :class="{'selectHover1':typeId === item.id}" class="selectHover d-none">
                      <img @click.stop="editClick(item)" alt="" class="w-15 h-15 m-r-10"
                           src="../../../assets/common/ic_xiugai.png">
                      <img @click.stop="delClick(item,2)" alt="" class="w-15 h-15"
                           src="../../../assets/common/ic_shanchu1.png">
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
          <el-col :span="15" class="h-full">
            <div class="h-full  flex-1">
              <div class="fs-16 flex a-center p-h-15"
                   style="color: #333333;height: 50px;border-bottom: 1px solid #EDEDED;">
                <slot name="classType">
                  <div class="fs-14">分组产品</div>
                </slot>
                <div @click="addProductClick" class="flex a-center m-l-20" v-if="groupId">
                  <span class="fs-14" style="color: #0652DD;cursor: pointer">添加商品</span>
                </div>
                <div class="m-l-20 fs-14" v-if="groupId">商品名称</div>
                <el-input size="small" style="width: 220px" class="m-l-10" clearable v-model="searchForm.productName"
                          v-if="groupId"
                          placeholder="请输入商品名称"></el-input>
                <el-button size="small" type="primary" icon="el-icon-search" class="m-l-20" @click="onSubmit"
                           v-if="groupId">
                  查询
                </el-button>
                <div class="flex-1"></div>
              </div>
              <div class="o-y-auto noscroll" style="height: calc(100% - 50px)">
                <div class="product-content p-20">
                  <div class="table-wrap">
                    <el-table size="small" :data="pTableData" border v-loading="loading">
                      <el-table-column prop="product.productName" label="产品" style="min-width: 400px">
                        <template slot-scope="scope">
                          <div class="product-info">
                            <div class="pic"><img v-img-url="scope.row.product.imagePath" alt=""/></div>
                            <div class="info">
                              <div class="name">{{ scope.row.product.productName }}</div>
                              <div class="price">￥{{ scope.row.product.productPrice }}</div>
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                      <!--                  <el-table-column prop="product.salesActual" label="实际销量" width="180"></el-table-column>-->
                      <!--                  <el-table-column prop="product.productStock" label="库存数" width="180"></el-table-column>-->
                      <!--                  <el-table-column prop="product.viewTimes" label="点击数" width="180"></el-table-column>-->
                      <el-table-column prop="product.createTime" label="添加时间" width="180"></el-table-column>
                      <el-table-column label="操作" width="80" align="center">
                        <template slot-scope="scope">
                          <el-button @click="delProductClick(scope.row)" type="text" size="small">删除
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <!--分页-->
                  <div class="pagination">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      background
                      :current-page="curPage"
                      :page-size="pageSize"
                      layout="total, prev, pager, next, jumper"
                      :total="totalDataNumber"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog title="添加分类分组" :visible.sync="dialogVisible" @close="dialogFormVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               top="5vh">
      <div style="display: block">
        <el-form size="mini" label-position="right" ref="editform" :model="editform" label-width="100px">
          <el-form-item label="分组名称:" prop="name" :rules="[{ required: true, message: '请输入分组名称' }]">
            <el-input v-model="editform.name" placeholder="分组名称" class="max-w460"></el-input>
          </el-form-item>
          <el-form-item label="排序:">
            <el-input v-model="editform.sort" placeholder="排序" class="max-w460"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="addProductGroup">确 定</el-button>
      </div>
    </el-dialog>
    <getproduct :isProduct="open_product" :islist="true" :dataType="1" :groupId="groupId"
                @closeDialog="closeDialogFunc($event, 'add')"/>
  </div>
</template>

<script>

import PorductApi from '@/api/product.js'
import getproduct from '@/components/product/GroupProduct.vue'
import LinkApi from '@/api/link.js'

export default {
  name: 'index',
  components: {getproduct},
  data () {
    return {
      loading: true,
      /*一页多少条*/
      pageSize: 20,
      /*总条数*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      dialogVisible: false,
      /*搜索参数*/
      searchForm: {
        // name: '',
        productName: ''
      },
      editform: {
        id: 0,
        name: '',
        sort: 100
      },
      typeTypeId: 0,
      typeId: 0,
      groupId: 0,
      pTableData: [],
      open_product: false,
      /*列表数据*/
      tableData: [],
      typeData: [],
      groupData: []
    }
  },
  computed: {},
  watch: {
    typeTypeId: {
      handler (newValue) {
        this.typeData = []
        if (newValue) {
          let selItem = this.tableData.find(e => {
            return e.id === this.typeTypeId
          })
          if (selItem && selItem.children && selItem.children.length) {
            this.typeData = selItem.children
            this.typeId = selItem.children[0].id || 0
          } else {
            this.typeId = 0
          }
        } else {
          this.typeId = 0
        }
      }
    },
    typeId: {
      handler (newValue) {
        this.groupData = []
        if (newValue) {
          let selItem = this.typeData.find(e => {
            return e.id === this.typeId
          })
          if (selItem && selItem.children && selItem.children.length) {
            this.groupData = selItem.children
            this.groupId = selItem.children[0].id || 0
          } else {
            this.groupId = 0
          }
        } else {
          this.groupId = 0
        }
      },
      immediate: true
    },
    groupId: {
      handler (newValue) {
        this.curPage = 1
        if (newValue) {
          this.getProductData()
        } else {
          this.pTableData = []
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getData()
    },
    getProductData () {
      let self = this
      let Params = self.searchForm
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      Params.groupId = self.groupId
      self.loading = true
      PorductApi.getGroupProductList(Params, true)
        .then(res => {
          self.loading = false
          self.pTableData = res.data.records
          self.totalDataNumber = res.data.total
        })
        .catch(error => {
          self.loading = false
        })
    },
    getData () {
      let self = this
      self.loading = true
      LinkApi.getAllGroupList({}, true).then(res => {
        self.loading = false
        self.tableData = res.data
        if (!self.typeTypeId) {
          self.typeTypeId = self.tableData[0].id
        }
        self.$nextTick(e => {
          self.refreshTypeGroupInfo()
        })
      }).catch(error => {
        self.loading = false
      })
    },
    refreshTypeGroupInfo () {
      this.typeData = []
      this.groupData = []
      if (this.typeTypeId) {
        let selItem = this.tableData.find(e => {
          return e.id === this.typeTypeId
        })
        if (selItem && selItem.children && selItem.children.length) {
          this.typeData = selItem.children
          if (!this.typeId) {
            this.typeId = selItem.children[0].id || 0
          }
        }
        if (this.typeId) {
          let selItem = this.typeData.find(e => {
            return e.id === this.typeId
          })
          if (selItem && selItem.children && selItem.children.length) {
            this.groupData = selItem.children
            if (!this.groupId) {
              this.groupId = selItem.children[0].id || 0
            }
          }
        }
      }
    },
    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.getProductData()
    },
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.curPage = val
      self.loading = true
      self.getProductData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.curPage = 1
      this.pageSize = val
      this.getProductData()
    },
    addClick (type) {
      let parentId = 0
      if (type === 2) {
        parentId = this.typeTypeId
      } else if (type === 3) {
        parentId = this.typeId
      }
      this.editform = {
        id: 0,
        parentId,
        name: '',
        sort: 100
      }
      this.dialogVisible = true
    },
    dialogFormVisible (e) {
      this.editform = {
        id: 0,
        name: '',
        sort: 100
      }
    },
    addProductGroup () {
      this.$refs.editform.validate((valid) => {
        if (valid) {
          let self = this
          let params = {}
          Object.assign(params, this.editform)
          if (this.editform.id) {
            PorductApi.editProductGroup(params).then(data => {
              self.$message({
                message: '操作成功',
                type: 'success'
              })
              this.getData()
              self.dialogVisible = false
            })
          } else {
            PorductApi.addProductGroup(params).then(data => {
              self.$message({
                message: '操作成功',
                type: 'success'
              })
              this.getData()
              self.dialogVisible = false
            })
          }
        }
      })
    },
    delClick: function (row, type) {
      let self = this
      self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        PorductApi.delProductGroup({
          groupId: row.id
        }).then(data => {
          self.$message({
            message: '删除成功',
            type: 'success'
          })
          if (type === 1) {
            if (row.id === this.typeId) {
              self.typeId = 0
            }
          } else if (type === 2) {
            if (row.id === this.groupId) {
              this.groupId = 0
            }
          }
          self.getData()
        })
      })
    },
    editClick (row) {
      this.editform = {
        id: row.id,
        name: row.name || '',
        sort: row.sort
      }
      this.dialogVisible = true
    },
    productClick (row) {
      let groupId = row.id
      this.$router.push({
        path: '/product/group/plist',
        query: {
          groupId
        }
      })
    },
    onTypeTypeSelect (item) {
      this.typeTypeId = item.id
    },
    onTypeSelect (item) {
      this.typeId = item.id
    },
    onGroupSelect (item) {
      this.groupId = item.id
    },
    closeDialogFunc (e) {
      let self = this
      if (e.type != 'error') {
        let productIds = []

        productIds = e.params.map(item => {
          return item.productId
        })

        let params = {
          groupId: self.groupId,
          productList: productIds
        }
        PorductApi.addGroupProduct(params).then(res => {
          self.$message({
            message: '添加成功',
            type: 'success'
          })
          self.getProductData()
        }).catch(err => {
          self.$message({
            message: err.msg || '添加失败',
            type: 'error'
          })
        })
      }
      this.open_product = false
    },
    /*打开添加*/
    addProductClick () {
      this.open_product = true
    },
    delProductClick: function (row) {
      let self = this
      let msg = ''
      msg = '删除后产品将从该分组中删除，确认删除该产品吗?'
      self.$confirm(msg, '提示', {
        type: 'warning'
      }).then(() => {
        PorductApi.DeleteGroupProduct({
          groupProductId: row.id
        }).then(data => {
          self.$message({
            message: '删除成功',
            type: 'success'
          })
          self.getProductData()
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.active {
  background: #EDF3FF;
  color: #0652DD;
}

.liHover:hover {
  background: #EDF3FF;

}

.liHover:hover .selectHover {
  display: flex;

}

.selectHover1 {
  display: flex;
}

.w-15 {
  width: 15px;
}

.h-15 {
  height: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/group/index.vue